<template>
    <div class="exam">
        <div class="vocabulary">{{vocabularyModel.ChineseDefinition}}</div>
        <div class="option">
            <div class="item" v-for="(item,index) in optionModel" :key="item.$id" @click.stop="sel({item,index})">
                <div class="txt">{{item.Text}}</div>
                <Placard class="icon" :x="isX" v-if="index===selIndex"></Placard>
            </div>
        </div>
    </div>
</template>
<script>
import examMixins from '@/components/exam/examMixins'
export default {
    name: 'Exam_3',
    mixins: [examMixins]
}
</script>
<style lang="less" scoped>
@import 'val.less';
.vocabulary {
    min-height: 100px;
    margin: 10px 10px 50px 10px;
    padding: 10px;
    border: @main-color solid 2px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    color: @main-color;
    background: url('../assets/img/group-4-copy-2.png');
    background-repeat: no-repeat;
    background-position: 20px -20px;
}
.option {
    .item {
        padding: 5px 20px;
        font-size: 20px;
        line-height: 55px;
        text-align: left;
        cursor: pointer;
        .txt {
            display: inline-block;
        }
        .icon {
            float: right;
        }
        &::before {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            margin: 0px 10px 2px 0px;
            background: @main-color;
            border-radius: 5px;
        }
        &:hover {
            background: #eff6f6;
        }
    }
}
@media (hover: none) {
    .option {
        .item {
            &:active {
                background: #eff6f6;
            }
            &:hover {
                background: transparent;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Exam_3.vue